export default "__VITE_ASSET__uPbvQL5d__"